import React, { useContext, useState } from "react";
import jQuery from "jquery";
import { CanvasContext, ModuleContext } from "../../provider";
import ImageCropper from "./ImageCropper";
import globalComp from "../../../../global/components";
import { ModuleInfoImage } from "../../../../Types";

function ImageCanvasTools_Prd() {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { moduleImages } = useContext(ModuleContext);
  const { canvasRef } = useContext(CanvasContext);

  const [isCropperVisible, setIsCropperVisible] = useState<boolean>(false);
  const [
    selectedImageUrl,
    setSelectedImageUrl,
  ] = useState<ModuleInfoImage | null>(null);

  function toggleCropper() {
    // Prevent cropper cases when user tries to crop preset image
    let canvasActiveObject = canvasRef.current.getActiveObject();
    let imgId;
    // @ts-ignore
    if (typeof canvasActiveObject.id === "string") {
      imgId = parseInt(
        // @ts-ignore
        canvasActiveObject.id.charAt(canvasActiveObject.id.length - 1)
      );
    } else {
      // @ts-ignore
      imgId = canvasActiveObject.id;
    }
    setSelectedImageUrl(moduleImages[imgId]);
    jQuery("#product-image-cropper-modal").modal("show");
    setIsCropperVisible(true);
  }

  return (
    <div className={"product-canvas__object-controls"}>
      {isCropperVisible && (
        <ImageCropper
          mountingParentId={"product-image-cropper-modal"}
          mountingParentBodyId={"product-image-cropper-modal-body"}
          doneButtonId={"product-image-cropper-modal-save-btn"}
          selectedImage={selectedImageUrl}
        />
      )}

      {moduleImages && moduleImages.length && (
        <globalComp.ControlButton
          onClick={toggleCropper}
          imgName={"edit.svg"}
          text={t.edit_image}
          imageStyle={{ width: 17 }}
          textStyle={{ flexShrink: 0 }}
        />
      )}
    </div>
  );
}

export default ImageCanvasTools_Prd;
